import _Vue from "vue";
import axios, {Axios} from "axios";
import app from "@/main";
import {Mixins} from "@/plugins/uyap-plugin/takip_ac/Mixins";
import * as xml2js from "xml2js";
import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {store} from "@/store";
import {promptForPin} from './utils/pin-modal';
import {hesapTckniOku, sikiModAcikMi, tcknNormalize} from './OturumKimligi';
import {
    kodluHata,
    imzaYanitiniSiniflandir,
    ImzaYanitSonucu,
    KART_YOK_MESAJI,
    IMZA_PROGRAMI_KAPALI_MESAJI,
    PIN_GEREKLI_MESAJI,
    PIN_YANLIS_MESAJI,
    PIN_KILITLI_MESAJI,
    KAYITLI_PIN_SILINDI_EKI,
    HESAP_TCKN_EKSIK_MESAJI,
    SERTIFIKA_TCKN_EKSIK_MESAJI
} from './imzaHatalari';
import {PinDeposu, PinKaydi} from './PinDeposu';
import {bildirimMetni} from './bildirimMetni';

const imzaciUrl = 'https://imza.eicrapro.com:6090/'
const proxyBaseUrl = 'https://imza.eicrapro.com:';
const avukatUyapUrl = 'https://imza.eicrapro.com:6081';
// Yeni imzalama uygulaması (localhost:5975) proxy adresi
const newSignerUrl = 'https://imza.eicrapro.com:6075';
/** İmza programının "PIN kilitli" dediği kartlar (certificateId listesi), sessionStorage anahtarı. */
const KILITLI_KARTLAR_ANAHTARI = 'imzaKilitliKartlar';

/**
 * Sign isteğinin cevabı imza programından değil kabuk proxy'sinden mi geldi (program kapalı, bağlantı
 * reddedildi)? Program kendi hatalarını `metadata` taşıyan JSON ile döner; proxy hatası düz metin/HTML
 * 5xx'tir. Bu durumda PIN karta hiç gitmemiştir.
 */
function programaUlasilamadiMi(cevap: any): boolean {
    const govde = cevap ? cevap.data : undefined;
    if (govde && typeof govde === 'object' && govde.metadata) {
        return false;
    }
    const durum = Number(cevap ? cevap.status : 0);
    const metin = typeof govde === 'string' ? govde : '';
    return durum === 502 || durum === 503 || /ECONNREFUSED|ENOTFOUND|EHOSTUNREACH/.test(metin);
}

export enum UYAP_PLATFORM_SOCKET {
    ARABULUCU_PORTAL = 6080,
    ARABULUCU_PORTAL_URL = "arabulucu.uyap.gov.tr",
    AVUKAT_PORTAL = 6081,
    AVUKAT_PORTAL_URL = "avukat.uyap.gov.tr",
}

/**
 * setApiCookiesToImza sonucu.
 *  - ok:true: kimlik devredildi (eskiKabuk: kabuk <= 1.3.3, eski yol kullanıldı).
 *  - ok:false / sebep 'eksik': token / kullanıcı / büro bilgisi henüz yok, hiçbir şey
 *    gönderilmedi. FIRLATMAZ (çağıran bekleyip yeniden dener).
 * Gönderilip de olmayan hâller (kabuk reddetti, imzacıya ulaşılamadı) ESKİSİ GİBİ
 * FIRLATILIR: Error.sebep = 'reddedildi' | 'ulasilamadi', Error.durum = HTTP kodu (varsa).
 * Böylece sonucu hiç okumayan eski çağıran (icrapro-app checkUyapSession) aynı kalır.
 */
export type SetConfigSonucu =
    | {ok: true, eskiKabuk: boolean, kabukSurumu?: string}
    | {ok: false, sebep: 'eksik', mesaj?: string};

function devirHatasi(sebep: 'reddedildi' | 'ulasilamadi', mesaj: string, durum?: number): Error {
    const hata: any = new Error(mesaj);
    hata.sebep = sebep;
    if (durum !== undefined) {
        hata.durum = durum;
    }
    return hata;
}

export function apiTipiBul(apiHedefi: string | undefined): string {
    switch (apiHedefi) {
        case 'http://localhost':
        case 'http://localhost:4000':
            return 'local';
        case 'https://apicloudicra.neova.com.tr':
            return 'neova';
        case 'https://apicloudtest.zirve-bilgisayar.com':
            return 'test';
        case 'https://apibeta.zirve-bilgisayar.com':
            return 'beta';
        case 'https://apicloud.zirve-bilgisayar.com':
            return 'canli';
        default:
            return 'local';
    }
}

/**
 * HTTP başlık değerleri ISO-8859-1'dir; Türkçe harfli JSON olduğu gibi gönderilirse
 * tarayıcı fırlatır. U+007F üstü her karakter \uXXXX kaçışına çevrilir; kabuğun
 * JSON.parse'ı bunu aynen çözer.
 */
export function xTenantBasligi(tenantId: string, title: string): string {
    return JSON.stringify({tenant_id: tenantId, title: title})
        .replace(/[\u007f-\uffff]/g, (c) => '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4));
}

/** Kabuğun reddine kullanıcı dilinde açıklama (sunucu metni yoksa). */
function devirRedMesaji(e: any): string {
    const durum = e && e.response ? e.response.status : 0;
    const veri = e && e.response ? e.response.data : undefined;
    if (veri && typeof veri === 'object' && typeof veri.hata === 'string') {
        // Kabuk 2.0.5: {ok:false, hata:'gecersiz', alan}
        return 'İmzacı gönderilen kimlik bilgisini geçersiz buldu (' + veri.hata + (veri.alan ? ': ' + veri.alan : '') + ').';
    }
    if (durum === 403) {
        return 'İmzacı bu sayfadan gelen isteği kabul etmedi. Adresin izinli listede olduğundan emin olun.';
    }
    if (durum === 405) {
        return 'İmzacı sürümü bu isteği desteklemiyor. İmzacıyı güncelleyin.';
    }
    return bildirimMetni(e, 'İmzacı kimlik bilgisini kabul etmedi.');
}

function tokenGecerliMi(token: string): boolean {
    return /^[A-Za-z0-9._~+/=-]+$/.test(token) && token !== 'undefined' && token !== 'null';
}

function zamanAsimli<T>(soz: Promise<T>, ms: number): Promise<T | null> {
    return new Promise<T | null>((cozum) => {
        const zamanlayici = setTimeout(() => cozum(null), ms);
        soz.then(
            (deger) => { clearTimeout(zamanlayici); cozum(deger); },
            () => { clearTimeout(zamanlayici); cozum(null); }
        );
    });
}

class ImzaClient {
    simulator = false;
    private pinDeposu: PinDeposu = new PinDeposu(
        () => window.localStorage,
        () => {
            // Gerçek tip yalnız kabuk 2.0.5'te var; eski kabukta/tarayıcıda tanımsız.
            const pencere: any = window;
            const zirvelib: any = pencere.zirvelib;
            return zirvelib && zirvelib.guvenliDepo ? zirvelib.guvenliDepo : null;
        }
    );
    availableCardsPromise: Promise<any>|null = null;
    betaLoginPromise: Promise<any>|null = null;

    constructor() {
        // PIN deposu istemci kurulurken bir kez açılır (fire-and-forget; yukle() idempotent ve
        // hata fırlatmaz). `pinDeposunuYukle()`'yi hiç çağırmayan bir host (eski vue-imza-app +
        // yeni plugin) kartPinKayitliMi'yi senkron çağırsa da şifreli PIN'ler görünür: çözme
        // (IPC) milisaniyeler sürer, kart listesi ve eİcraPro kapısı saniyeler. Güvenli depo
        // yoksa (icrapro-app, eski kabuk) yalnız düz anahtar okunur, davranış değişmez.
        this.pinDeposu.yukle().catch(() => undefined);
    }

    private ensureTcknInSession(): string | null {
        let t = sessionStorage.getItem('tckn');
        const isValid = (val: any) => typeof val === 'string' && /^\d{11}$/.test(val);
        if (!isValid(t)) {
            try {
                const s = store?.getters?.userData?.kimlik_no;
                if (isValid(String(s))) {
                    t = String(s);
                    sessionStorage.setItem('tckn', t);
                } else {
                    t = null;
                }
            } catch (_e) {
                t = null;
            }
        }
        return t;
    }

    setSimulator() {
        this.simulator = true;
    }

    heartbeat() {
        console.log('heartbeat() fonksiyonu başlatıldı');
        const xml = '<root><auth><token></token><hash></hash></auth><data></data></root>';
        return new Promise(async (s, f) => {
            if (this.simulator) {
                return s("");
            }
            try {
                let data = await axios.post(imzaciUrl + 'xml/heartbeat', {xml: xml}, {
                    withCredentials: true
                });
                return s(data);
            } catch (e) {
                //console.log('fail');
                return f(e);
            }
        });
    }
    /**
     * Kimliği (token, büro, TCKN) imzacıya devreder: kabuğun /setConfig ucuna
     * başlıklarla POST. UyapRequest DEĞİL düz axios: bu yerel bir çağrı, UYAP isteği
     * değil (kimlik kapısı, spinner, metrik, 401 kurtarması burada anlamsız).
     */
    async setApiCookiesToImza(): Promise<SetConfigSonucu> {
        const token = String(store.getters.accessToken ?? '').trim();
        const kullanici: any = store.getters.userData;
        if (!tokenGecerliMi(token) || !kullanici || !kullanici.id) {
            return {ok: false, sebep: 'eksik', mesaj: 'Oturum bilgileri henüz yüklenmedi.'};
        }

        // TCKN: yalnız 11 hane; yoksa boş (asla 'null'/'undefined' dizesi).
        const kimlikNo = String(kullanici.kimlik_no ?? '').trim();
        const tckn = /^\d{11}$/.test(kimlikNo) ? kimlikNo : '';
        // Session storage'a TCKN'yi kaydet (imza doğrulama için). 11 hane değilse SİLİNİR:
        // kimlik_no'su boş bir kullanıcıya geçişte eski kullanıcının TCKN'si kimlik
        // kapısında kalmasın.
        if (tckn) {
            sessionStorage.setItem('tckn', tckn);
        } else {
            sessionStorage.removeItem('tckn');
        }

        // tenantData action'ı büro listesi hata verirse hiç dönmeyebiliyor; sınırlı beklenir.
        const tenant: any = await zamanAsimli(store.dispatch('tenantData'), 8000);
        const durum: any = store.state;
        const tenantId = String((tenant && tenant.tenant_id) || durum.tenant_id || '').trim();
        if (!tenantId) {
            return {ok: false, sebep: 'eksik', mesaj: 'Büro bilgisi henüz yüklenmedi.'};
        }
        const baslik = String((tenant && tenant.title) || '');

        const apiType = apiTipiBul(process.env.VUE_APP_API_TARGET);
        const setConfigUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL + '/setConfig';
        try {
            const cevap = await axios.post(setConfigUrl, undefined, {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'X-Tenant': xTenantBasligi(tenantId, baslik),
                    'X-Tckn': tckn,
                    'X-Api-Type': apiType
                },
                withCredentials: false,
                timeout: 5000
            });
            this.tokenGuncellendiBildir();
            const surum = cevap && cevap.data ? cevap.data.kabukSurumu : undefined;
            return typeof surum === 'string'
                ? {ok: true, eskiKabuk: false, kabukSurumu: surum}
                : {ok: true, eskiKabuk: false};
        } catch (e) {
            if (e && e.response) {
                // Kabuk cevap verdi ama kabul etmedi: eski yola düşmenin anlamı yok.
                throw devirHatasi('reddedildi', devirRedMesaji(e), e.response.status);
            }
            if (e && e.code === 'ECONNABORTED') {
                throw devirHatasi('ulasilamadi', 'İmzacı yanıt vermedi.');
            }
        }

        // Cevap hiç gelmedi: ön kontrol reddi (kabuk <= 1.3.3 özel başlıkları bilmez) ya da
        // imzacı kapalı. Bir kez ESKİ yol: bilgiler sorgu dizesinde. UyapRequest/SetCookie
        // DEĞİL düz axios: kimlik kapısı, spinner ve oturum kurtarma döngüsü devreye girmesin.
        try {
            const eskiUrl = encodeURI(setConfigUrl + '?token=' + 'Bearer ' + token +
                '&tenant=' + JSON.stringify(tenant || {tenant_id: tenantId, title: baslik}) +
                '&tckn=' + tckn + '&apiType=' + apiType);
            await axios.post(eskiUrl, undefined, {withCredentials: true, timeout: 5000});
            this.tokenGuncellendiBildir();
            return {ok: true, eskiKabuk: true};
        } catch (e) {
            throw devirHatasi('ulasilamadi', bildirimMetni(e, 'İmzacı programına ulaşılamadı.'));
        }
    }

    private tokenGuncellendiBildir(): void {
        // Yüksüz: token socket'ten TAŞINMAZ, imzacı kabuğun yazdığı kimliği okur.
        _Vue.prototype.$socket.client.emit("updateToken");
    }


    async setCookieToImza() {
        if (window.sessionStorage.hasOwnProperty("INJECT_JSESSIONID")) {
            let jsessionId = window.sessionStorage.getItem("INJECT_JSESSIONID");
            const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/cookie?JSESSIONID=' + jsessionId + ';SameSite=None;Secure';
            await app.$uyap.SetCookie().run({url: cookieSetUrl});
        }
    }

    async changePlayerStatus(status: PlayerDurum) {
        const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/putTaskPlayerStatus?' + status;
        await app.$uyap.ChangePlayerStatus().run({url: cookieSetUrl});
    }

    async getPlayerStatus() {
        const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/getTaskPlayerStatus';
        return await app.$uyap.ChangePlayerStatus().run({url: cookieSetUrl});
    }

    sendImzaMessage(msg: any){
        _Vue.prototype.$socket.client.emit("imzaMessage",msg);
    }

    async availableCards(){
        try{
            if (this.availableCardsPromise) {
                return this.availableCardsPromise;
            }
            this.availableCardsPromise = (async () => {
                try {
                    // Tek istek. Önceden ayrıca bir "imzalama uygulaması ayakta mı"
                    // yoklaması vardı ve aynı ucu ikinci kez çağırıyordu; kart bir kez
                    // kullanıldıktan sonra bu uç ~4 sn sürdüğü için her tazeleme boşuna
                    // iki katına çıkıyordu. Uygulama kapalıysa zaten bu istek patlar.
                    let certsResponse;
                    try {
                        certsResponse = await axios.get(newSignerUrl + '/api/v1/signature/getCertificates');
                    } catch (e) {
                        // "program" kelimesi korunmalı: store'daki availableCards action'ı
                        // kart bulununca bu metni 'kart'/'imzacı'/'program' geçen mesajlara
                        // bakarak temizliyor.
                        throw kodluHata(IMZA_PROGRAMI_KAPALI_MESAJI, 'IMZA_PROGRAMI_KAPALI');
                    }
                    const responseData = certsResponse.data;

                    if (!responseData?.data || !Array.isArray(responseData.data)) {
                        throw new Error('Sertifika listesi alınamadı.');
                    }

                    // Her terminal için sertifikaları düzleştir
                    const cardList: any[] = [];
                    for (const terminal of responseData.data) {
                        if (!Array.isArray(terminal.certificates)) continue;
                        for (const cert of terminal.certificates) {
                            cardList.push({
                                // Eski yapıyla uyumluluk için sarmalayıcı
                                terminal: terminal.terminal,
                                serialNumber: terminal.serialNumber,
                                certificate: cert
                            });
                        }
                    }

                    store.commit('setAvailableCardList', cardList);
                    return cardList;

                } finally {
                    this.availableCardsPromise = null;
                }
            })();

            return this.availableCardsPromise;

        }catch (e) {
            console.log("availableCards error", e);
            this.sendImzaMessage({
                title: "UYAP IMZA UYGULAMASI HATA!",
                text:  e.message,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Tamam'
            });
        }
    }
    /**
     * PIN deposunu açar (idempotent). Kabuk 2.0.5 güvenli depo sunuyorsa PIN'ler
     * şifreli tutulur ve çözülmüş kopya belleğe alınır; `kartPinKayitliMi` senkron
     * kalabilsin diye host, kart gözlemcisi/otomatik giriş BAŞLAMADAN önce bunu bekler.
     */
    pinDeposunuYukle(): Promise<void> {
        return this.pinDeposu.yukle();
    }
    getPinCodes(): PinKaydi[] {
        return this.pinDeposu.oku();
    }
    setPinCodes(val: PinKaydi[]): void {
        this.pinDeposu.kaydetSenkron(val);
    }
    /** Görünür bir pencere (PIN, hata/uyarı) açılmadan hemen önce imzacı penceresini öne alır. */
    private async pencereyiOneAl(): Promise<void> {
        try {
            await axios.post(imzaciUrl + 'focus');
        } catch (_e) {
            // Odak yardımcıdır; başarısızlığı girişi ya da asıl hatayı gölgelememeli.
        }
    }

    /**
     * @param sessiz Otomatik (arka plan) deneme. HİÇBİR pencere açılmaz: PIN sorulmaz,
     *               hata/uyarı modalı yok, pencere öne alınmaz. Giriş yapılamıyorsa hata
     *               kodlu fırlatılır (`(e as any).kod`: PIN_GEREKLI, KART_YOK,
     *               IMZA_PROGRAMI_KAPALI, TCKN_EKSIK; bkz. imzaHatalari.ts) ve çağıran
     *               durumu kendi yüzeyinde gösterir. Kayıtlı PIN'i olsa bile kartta
     *               "otomatik oturum aç" kapalıysa PIN kullanılmaz (PIN_GEREKLI).
     *               Tek istisna güvenlik uyarısı "İzinsiz İmza": sessizde de gösterilir.
     */
    async betaLogin(sessiz: boolean = false) {
        console.log("this.betaLoginPromise",this.betaLoginPromise);
        // Eğer zaten çalışıyorsa mevcut Promise’i döndür
        if (this.betaLoginPromise) {
            return this.betaLoginPromise;
        }
        // Fonksiyonun gerçek işini yapan Promise'i oluştur
        this.betaLoginPromise = (async () => {
            try {
                // Şifreli PIN deposu açılmadan kayıtlı PIN aranmaz.
                await this.pinDeposunuYukle();
                const siki = sikiModAcikMi();
                let cardList = await this.availableCards();
                if (!Array.isArray(cardList) || cardList.length === 0) {
                    throw kodluHata(KART_YOK_MESAJI, 'KART_YOK');
                }
                // Hesap TCKN'si: kayıtlı kaynaktan (imzacı: lisans TCKN'si), yoksa eskisi gibi
                // oturum deposundan. Sıkı modda bilinmiyorsa kart/PIN/imza aşamasına HİÇ geçilmez.
                const hesapTckn = tcknNormalize(hesapTckniOku(() => this.ensureTcknInSession()));
                if (siki && !hesapTckn) {
                    throw kodluHata(HESAP_TCKN_EKSIK_MESAJI, 'TCKN_EKSIK');
                }
                const preferredSerial: string | null = store.getters.selectedCardSerial ?? null;
                // Yeni yapıda kart kimliği certificate.certificateId
                let card = cardList.find((c: any) => c?.certificate?.certificateId === preferredSerial);
                if (!card && hesapTckn) {
                    // Seçim yoksa körlemesine cardList[0] almak yanlış avukatın
                    // kartıyla giriş demek; TCKN elde varken önce onunla eşleştir.
                    card = cardList.find(
                        (c: any) => tcknNormalize(c?.certificate?.subjectSerial) === hesapTckn
                    );
                }
                if (!card) {
                    if (cardList.length > 1) {
                        throw new Error(
                            'Birden fazla e-imza kartı takılı ve hesabınıza ait olan belirlenemedi. ' +
                            'Üst menüden kullanmak istediğiniz kartı seçiniz.'
                        );
                    }
                    // Tek kart. Sıkı modda aşağıdaki TCKN denetimi eşleşmeyen kartı reddeder
                    // (TCKN eşleşmeden giriş yapılamaz); eski modda eskisi gibi devam.
                    card = cardList[0];
                }

                // TCKN kontrolü - yeni yapıda subjectSerial düz metin (base64 değil)
                const certTckn = tcknNormalize(card.certificate.subjectSerial);
                console.log('Beta Login - Sertifika TCKN okundu:', certTckn !== '');
                if (siki && !certTckn) {
                    throw kodluHata(SERTIFIKA_TCKN_EKSIK_MESAJI, 'TCKN_EKSIK');
                }
                if (hesapTckn && certTckn && hesapTckn !== certTckn) {
                    console.error('TCKN uyuşmazlığı! Hesap ile sertifika TCKN farklı.');
                    throw {type: 'unauthorized', message: 'İzinsiz İmza'};
                } else if (!hesapTckn) {
                    console.warn('Hesap TCKN bulunamadı, kontrol atlanıyor');
                } else {
                    console.log('TCKN kontrolü başarılı');
                }
                store.commit('setSelectedCardSerial', card.certificate.certificateId);

                let pinCodes = this.getPinCodes();
                // Yeni yapıda seri no: certificate.certificateId (düz metin)
                const currentSerial = card.certificate.certificateId;
                console.log("currentSerial", currentSerial);
                let cardPin = pinCodes.find((item: any) => item.cardSerialNumber === currentSerial);

                let pinCode: string;
                // Yeni girilen PIN yalnız imza BAŞARILI olursa kaydedilir: yanlış PIN depoya girip
                // sonraki denemelerde (Bağlan, sessiz bot girişi) karta yeniden gönderilmesin.
                let yeniPinKaydi: PinKaydi | null = null;
                if (sessiz) {
                    // Kilitli karta sessizce imza denenmez; neden "PIN gerekli" değil "kilitli" kalsın.
                    if (this.kartPinKilitliMi(currentSerial)) {
                        throw Object.assign(kodluHata(PIN_KILITLI_MESAJI, 'PIN_KILITLI'), {serialNumber: currentSerial});
                    }
                    // Arka planda PIN penceresi AÇILMAZ ve otomatik girişi kapatmış kartın PIN'i kullanılmaz.
                    if (!cardPin || !cardPin.pinCode || cardPin.autoLogin === false) {
                        throw kodluHata(PIN_GEREKLI_MESAJI, 'PIN_GEREKLI');
                    }
                    pinCode = cardPin.pinCode;
                } else if (!cardPin) {
                    await this.pencereyiOneAl();
                    const formValues = await promptForPin({
                        ownerName: card.certificate.subject,
                        title: 'İmza Pin Kodu',
                        rememberLabel: 'Otomatik oturum aç',
                        minLen: 4,
                        maxLen: 12
                    });

                    if (!formValues) {
                        throw new Error('İmza işlemi iptal edildi');
                    }

                    pinCode = formValues.pin;
                    const autoLoginEnabled = formValues.remember;

                    console.log('Otomatik oturum aç:', autoLoginEnabled);

                    yeniPinKaydi = {
                        cardOwnerName: card.certificate.subject,
                        cardSerialNumber: currentSerial,
                        pinCode: pinCode,
                        autoLogin: autoLoginEnabled
                    };
                } else {
                    pinCode = cardPin.pinCode;
                }

                // UYAP sabit challenge metni (HAR'dan alındı)
                const UYAP_SIGN_CONTENT = 'QWRhbGV0IEJha2FubMSxxJ/EsSBCaWxnaSDEsMWfbGVtIEdlbmVsIE3DvGTDvHJsw7zEn8O8IHRhcmFmxLFuZGFuIGdlbGnFn3RpcmlsZW4gdXlndWxhbWF5YSBlLWltemEgZ2lyacWfIHlhcG1hayBpc3RpeW9ydW0u';

                // Yeni imzalama uygulaması ile imzala. Program hatayı çoğunlukla HTTP 200 ile gövdede
                // döner ({"data":null,"metadata":{"STATUS":"ERROR","MESSAGE":"PIN kilitli."}}); sonuç
                // HTTP durumundan değil gövdeden sınıflandırılır (imzaYanitiniSiniflandir).
                let imzaSonucu: ImzaYanitSonucu;
                try {
                    const signResponse: any = await axios.post(newSignerUrl + '/api/v1/signature/sign', {
                        certificateId: card.certificate.certificateId,
                        password: pinCode,
                        content: UYAP_SIGN_CONTENT
                    });
                    imzaSonucu = imzaYanitiniSiniflandir(signResponse?.data);
                } catch (e) {
                    if (e && (!e.response || programaUlasilamadiMi(e.response))) {
                        // İmzalama uygulaması cevap vermedi (kapandı/kart listesinden sonra düştü) ya da
                        // kabuk proxy'si ona bağlanamadı: PIN karta hiç ulaşmadı, kayıtlı PIN korunur.
                        throw kodluHata(IMZA_PROGRAMI_KAPALI_MESAJI, 'IMZA_PROGRAMI_KAPALI');
                    }
                    imzaSonucu = imzaYanitiniSiniflandir(e.response.data);
                    if (imzaSonucu.durum === 'tamam' || (imzaSonucu.durum === 'hata' && e.response.status === 401)) {
                        // 401 gövdede başka bir şey söylemiyorsa yanlış PIN'dir.
                        imzaSonucu = e.response.status === 401
                            ? {durum: 'pin-yanlis', mesaj: imzaSonucu.durum === 'hata' ? imzaSonucu.mesaj : ''}
                            : {durum: 'hata', mesaj: 'HTTP ' + e.response.status};
                    }
                }

                if (imzaSonucu.durum !== 'tamam') {
                    // Program PIN'i karta götürdü ve imza alınamadı. Kayıtlı PIN HER durumda silinir:
                    // yanlış PIN'in yeniden gönderilmesi kartı kilitler (her deneme kartın hakkından
                    // düşer); geçerli bir PIN'i bir kez yeniden girmek bunun yanında küçük bir bedel.
                    const kayitliPinVardi = pinCodes.some((item: any) => item.cardSerialNumber === currentSerial);
                    if (kayitliPinVardi) {
                        pinCodes = pinCodes.filter((item: any) => item.cardSerialNumber !== currentSerial);
                        this.setPinCodes(pinCodes);
                    }
                    const silindiEki = kayitliPinVardi ? KAYITLI_PIN_SILINDI_EKI : '';
                    if (imzaSonucu.durum === 'pin-kilitli') {
                        this.kilitliKartIsaretle(currentSerial, true);
                        throw Object.assign(kodluHata(PIN_KILITLI_MESAJI, 'PIN_KILITLI'),
                            {type: 'pin-kilitli', serialNumber: currentSerial});
                    }
                    if (imzaSonucu.durum === 'pin-yanlis') {
                        // Sessiz tekrar YOK (kart kilitlenebilir), insan girmeli.
                        throw {type: 'pin', message: PIN_YANLIS_MESAJI + silindiEki, serialNumber: currentSerial, kod: 'PIN_GEREKLI'};
                    }
                    // PIN'le ilgisi bilinmeyen imza hatası: kart kilitlenmesin diye yine insan gerekir.
                    throw Object.assign(new Error(
                        'E-imza programı imzalayamadı' + (imzaSonucu.mesaj ? ': ' + imzaSonucu.mesaj : '.') +
                        silindiEki + ' "Bağlan"a basıp PIN kodunuzu yeniden girin.'
                    ), {kod: 'PIN_GEREKLI', serialNumber: currentSerial});
                }
                const signedData = imzaSonucu.signedData;
                const txId = imzaSonucu.txId;
                // İmza alındı: PIN doğru. Yeni girildiyse şimdi kaydedilir, kilit işareti kalkar.
                this.kilitliKartIsaretle(currentSerial, false);
                if (yeniPinKaydi) {
                    pinCodes = pinCodes.filter((item: any) => item.cardSerialNumber !== currentSerial);
                    pinCodes.push(yeniPinKaydi);
                    this.setPinCodes(pinCodes);
                }

                // HAR'a göre: GET web1.uyap?signature=...&txId=...
                let newAxios = new Axios({
                    withCredentials: true,
                });
                await newAxios.get(avukatUyapUrl + '/clearCookies');
                const web1Res = await newAxios.get(avukatUyapUrl + '/web1.uyap', {
                    params: {
                        signature: signedData,
                        txId: txId
                    }
                });
                window.sessionStorage.setItem("JSESSIONID", web1Res.headers.cookie ?? '');

                await newAxios.post(avukatUyapUrl + '/login.uyap', {});
                // Giriş sonrası pencereyi öne alma kaldırıldı: arkasında gösterilecek bir
                // pencere yok; odak yalnız görünür bir pencere açılmadan hemen önce alınır.
                this.betaLoginPromise = null;
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log("ERROR", e);
                if (e?.type == "unauthorized") {
                    // Güvenlik uyarısı: sessizde de gösterilir.
                    await this.pencereyiOneAl();
                    this.sendImzaMessage({
                        title: "İzinsiz İmza",
                        text:  "Hesabınızda kayıtlı TC kimlik numarası ile e-İmza kartındaki TC kimlik numarası uyuşmamaktadır. Lütfen kendi hesabınızla giriş yapın ve size ait e-İmza kartını kullanın. Sorunun devam ettiğini düşünüyorsanız, Cloud ekranında Ctrl + Shift + R tuşlarına basarak sayfayı yenileyebilir ve tekrar deneyebilirsiniz.",
                        icon: "warning",
                        allowOutsideClick: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Tamam'
                    });

                } else if (sessiz) {
                    // Otomatik (arka plan) deneme: kullanıcı bir şey istemedi, modal
                    // açmak rahatsız edici olur. İzinsiz İmza bunun dışında — o bir
                    // güvenlik uyarısı ve kullanıcının görmesi gerekiyor (yukarıda).
                    // Hata yine fırlatılıyor; durum kartına ve loga düşüyor.
                } else if (e.message && e.message.includes("Failed to execute 'atob'")) {
                    await this.pencereyiOneAl();
                    this.sendImzaMessage({
                        title: "İmza Kartı Bulunamadı",
                        text:  "İmza kartının bilgisayara takılı olduğundan ve sürücülerinin yüklü olduğundan emin olun.",
                        icon: "warning",
                        allowOutsideClick: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Tamam'
                    });
                } else {
                    await this.pencereyiOneAl();
                    this.sendImzaMessage({
                        title: e?.kod === 'PIN_KILITLI'
                            ? "E-imza kartının PIN kodu kilitli"
                            : e?.type === 'pin' ? "PIN kodu yanlış" : "UYAP oturumu açılırken bir hata oluştu.",
                        text:  e.message,
                        icon: "error",
                        allowOutsideClick: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Tamam'
                    });
                }
                // Hata YUTULMAZ. Eskiden burada throw yorum satırındaydı: giriş
                // başarısız olsa bile promise resolve ediyor, connectToUyap durumu
                // ancak arkasından gelen loadUyapMetaData patlayınca fark ediyordu.
                // Otomatik giriş akışı ise "başarılı" sanıp geri çekilmeyi hiç
                // uygulamayacaktı.
                const hata: any = e instanceof Error ? e : new Error(e?.message ?? String(e));
                // Düz nesne olarak fırlatılan hatalarda tür ve kod kaybolmasın.
                if (e && !(e instanceof Error)) {
                    if (e.type && !hata.type) hata.type = e.type;
                    if (e.kod && !hata.kod) hata.kod = e.kod;
                    if (e.serialNumber && !hata.serialNumber) hata.serialNumber = e.serialNumber;
                }
                if (!hata.kod && hata.message && hata.message.includes("Failed to execute 'atob'")) {
                    hata.kod = 'KART_YOK';
                }
                throw hata;
            } finally {
                // İşlem bittiğinde lock’u sıfırla
                this.betaLoginPromise = null;
            }
        })();
        // Promise’i döndür
        return this.betaLoginPromise;
    }

    /**
     * Bu oturumda imza programı kartın PIN'ini kilitli bildirdi mi. Bot bu kartla sessizce imza
     * denemez ve bekleme nedeni "PIN gerekli" değil "PIN kilitli" olur. Kullanıcı Bağlan'a basıp
     * PIN girerse yine denenir (kilit PUK ile açılmış olabilir); başarılı imzada işaret kalkar.
     */
    kartPinKilitliMi(cardSerialNumber: string | null): boolean {
        return Boolean(cardSerialNumber) && this.kilitliKartlariOku().indexOf(String(cardSerialNumber)) >= 0;
    }

    /** Kilit işareti sessionStorage'da tutulur: pencere yenilemesinde "PIN gerekli"ye düşmesin. */
    private kilitliKartlariOku(): string[] {
        try {
            const deger = JSON.parse(window.sessionStorage.getItem(KILITLI_KARTLAR_ANAHTARI) || '[]');
            return Array.isArray(deger) ? deger.map(String) : [];
        } catch (_e) {
            return [];
        }
    }

    private kilitliKartIsaretle(cardSerialNumber: string, kilitli: boolean): void {
        const liste = this.kilitliKartlariOku().filter((seri) => seri !== cardSerialNumber);
        if (kilitli) {
            liste.push(cardSerialNumber);
        }
        try {
            if (liste.length) {
                window.sessionStorage.setItem(KILITLI_KARTLAR_ANAHTARI, JSON.stringify(liste));
            } else {
                window.sessionStorage.removeItem(KILITLI_KARTLAR_ANAHTARI);
            }
        } catch (_e) {
            // Depo yoksa işaret yalnız bu çağrıda geçerli olur; güvenlik PIN silmeye dayanır.
        }
    }

    /** Kartın PIN'i kayıtlı mı. Otomatik giriş yalnızca kayıtlıysa denenir. */
    kartPinKayitliMi(cardSerialNumber: string | null): boolean {
        if (!cardSerialNumber) {
            return false;
        }
        const kayit = this.getPinCodes().find((item: any) => item.cardSerialNumber === cardSerialNumber);
        return Boolean(kayit?.pinCode) && kayit?.autoLogin !== false;
    }

    mesajImzala() {
        const myXml = '<root>' +
            '<auth><token></token></auth>' +
            '<data><message>Emre deneme imzala</message></data>' +
            '</root>';
        //readResult = reader.result.split(',')[1];
        axios.post(imzaciUrl + "xml/mesajImzala", myXml, {
            headers: {
                "Content-Type": "application/xml;charset=UTF-8"
            }
        })
    }



    icrapro80VeriAktar(dosyaEsasNo: any, icraDairesi: any, kartId: any, klasor: any) {
        return new Promise((resolve, reject) => {
            const xml = "<dosyaEsasNo>" + dosyaEsasNo + "</dosyaEsasNo><icraDairesi>" + icraDairesi + "</icraDairesi><kartId>" + kartId + "</kartId><icraproKlasor>" + klasor + "</icraproKlasor>";
            let myXml = "<root>\n" +
                "<auth>\n" +
                "<token></token>\n" +
                "<hash></hash>\n" +
                "</auth>\n" +
                "<data>\n" +
                "<b64Xml>" + Mixins.utf8_to_b64(xml) + "</b64Xml>\n" +
                "</data>\n" +
                "</root>"
            axios.post(imzaciUrl + 'xml/setDosyaEsasNo', myXml, {
                headers: {
                    "Content-Type": "application/xml;charset=UTF-8"
                }
            }).then((data) =>{
                return resolve(data)
            }).catch((err)=>{
                return reject(err);
            });
        })
    }

    dokumanImzala(data: Blob) {
        return new Promise((resolve, reject) => {
            if (this.simulator) {
                resolve("");
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(data); //udf base64 ceviriliyor..
            reader.onloadend = function () {
                //console.log("reader Result",reader.result);
                let b64Udf;
                if (typeof reader.result == "string") {
                    b64Udf = reader.result.split(',')[1];
                } else {
                    return reject('Dosya okunurken hata oluştu');
                }
                //console.log("b64UDF", b64Udf);

                //127.0.0.1:4723/xml/dokumanImzala
                //* blob data reader ile base 64 e ceviriliyor imzaciya gonderiliyor...

                const myXml = '<root>' +
                    '<auth><token></token></auth>' +
                    '<data><code>' + b64Udf + '</code></data>' +
                    '</root>';
                //readResult = reader.result.split(',')[1];
                axios.post(imzaciUrl + "xml/b64imzala", myXml, {
                    headers: {
                        "Content-Type": "application/xml;charset=UTF-8"
                    }
                }).then((data) => {
                    let parseString = xml2js.parseString;
                    parseString(data.data, {explicitArray: false}, (error: Error | null, result: any) => {
                        if (error) {
                            return reject(error);
                        }
                        //console.log("RESULT IMZALANMA", result);
                        return resolve(result.root.file);
                    });
                }).catch(function (err) {
                    if (err.response) {
                        let parseString = xml2js.parseString;
                        parseString(err.response.data, {explicitArray: false}, (error: Error | null, result: any) => {
                            app.$toast.error("Hata Kodu " + err.response.status + ": " + result.root.error_title);
                        });
                    } else if (err.request) {
                        app.$toast.error("İmzacı bağlantı hatası.");
                    } else {
                        app.$toast.error("Bilinmeyen hata (" + err.message + ")");
                    }
                    return reject(err);
                });

            };
        });
    }

    getFileFromLocalPath(path: string) {
        return new Promise((resolve, reject) => {
            let myXml = "<root>\n" +
                "<auth>\n" +
                "<token></token>\n" +
                "<hash></hash>\n" +
                "</auth>\n" +
                "<data>\n" +
                "<b64Xml>" + Mixins.utf8_to_b64("<path>" + path + "</path>") + "</b64Xml>\n" +
                "</data>\n" +
                "</root>"
            axios.post(imzaciUrl + "xml/getXmlContent", myXml, {
                headers: {
                    "Content-Type": "application/xml;charset=UTF-8"
                }
            }).then((data) => {
                let replacedData = String(data.data).replace(/\n/g, "");
                let parseString = xml2js.parseString;
                parseString(replacedData, {explicitArray: false}, (error: Error | null, jsonData: any) => {
                    if (error) {
                        return reject(error);
                    }
                    if (typeof jsonData.root.file != "undefined") {
                        return resolve(jsonData.root);
                    } else {
                        return reject({message: "Dosya bulunamadı !"});
                    }
                });
            }).catch(err => {
                return reject(err);
            })
        });
    }

    serialize(obj: any) {
        let str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

}

export default function ImzaClientPlugin(Vue: typeof _Vue): void {
    // do stuff with options
    Vue.prototype.$imza = new ImzaClient();
}
